// extracted by mini-css-extract-plugin
module.exports = {"answerData":"styles_answerData__1P-l8","answerDataTitle":"styles_answerDataTitle__4N_Zj"};